import type { UserProfile } from '~/types';
import { EditProfile } from './EditProfile';
import { useSubmit } from 'react-router';

interface Props {
  profiles: UserProfile[];
  profilesCanBeDeleted: boolean[];
}

export function EditExistingProfiles({
  profiles,
  profilesCanBeDeleted,
}: Props) {
  const submit = useSubmit();

  function handleProfileChange(profile: UserProfile) {
    const formData = new FormData();
    formData.append('action', 'updateProfile');
    formData.append('profile', JSON.stringify(profile));
    submit(formData, {
      method: 'post',
    });
  }

  function handleProfileDelete(profile: UserProfile) {
    const formData = new FormData();
    formData.append('action', 'deleteProfile');
    formData.append('profile', JSON.stringify(profile));
    submit(formData, {
      method: 'post',
    });
  }

  return (
    <>
      {profiles.map((profile, index) => (
        <EditProfile
          key={profile.id}
          profile={profile}
          canBeDeleted={profilesCanBeDeleted[index]}
          onProfileChange={handleProfileChange}
          onProfileDelete={handleProfileDelete}
        />
      ))}
    </>
  );
}
